import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SpecialCharacters } from 'src/app/core/enums';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { TABS } from '../../location-profile-popup.constants';
import { CONSTS } from '../group/group.constants';
import { ConfigObject } from './config-item/config-item.model';
import { SECTIONS, UNITS } from './configuration.constants';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: false,
})
export class ConfigurationComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) unit!: 'I' | 'M';

  readonly CONSTANTS = CONSTS;
  readonly UNITS = UNITS;
  readonly TABS = TABS;
  readonly SECTIONS = SECTIONS;
  readonly SpecialCharacters = SpecialCharacters;
  readonly REGEX = SpecialCharacters.ALPHABET_NUMBER;

  readonly destroy = inject(DestroyRef);

  initialValue!: FormGroup;

  constructor(public readonly commonUtils: CommonUtils) {}

  ngOnInit(): void {
    this.initialValue = { ...this.form.getRawValue() };
  }

  getConfig(control: string): FormGroup {
    return this.form.get(control) as FormGroup;
  }

  getGslConfig(control: string): FormGroup {
    return this.form.get('gslConfigurations')?.get(control) as FormGroup;
  }

  getCustomerConfig(control: string): FormGroup {
    return this.form.get('customerConfigs')?.get(control) as FormGroup;
  }

  checkCvisSmartDisabled(item: ConfigObject) {
    return (
      item.control === 'cvisSmartEnabled' &&
      this.form.get('externalSystems')?.get('collectShippers')?.value === false
    );
  }

  get getPdws() {
    return this.form.get('externalSystems')?.get('pdwsTolerance') as FormGroup;
  }

  get getTopSectionDetails(): FormGroup {
    return this.form.get('topSection') as FormGroup;
  }
}
